<template>
  <div v-if="isshow" class="refund-status">
    <div class="head">
		<h2>{{ status_info.status_msg }}</h2>
		<p>{{ status_info.time_msg }}</p>
		<div v-if="status_info.content_msg != 1">
			<div class="headinfo" :class="isInfoShow ? 'smallinfo' : ''">
				<p v-for="(item,key) in status_info.content_msg" :key="key">{{ item }}</p>
			</div>
			<div v-if="isInfoShow" class="spread" @click="Spread()">更多说明 <i class="iconfont icon-anniu_jiantouzhankai_o"></i></div>
			<div v-if="!isInfoShow" class="spread" @click="Spread()">收起 <i class="iconfont icon-jian"></i></div>
		</div>
	</div>
	<!-- 退货地址 -->
	<div v-if="status_info.display_status.refund_address" class="refund-address">
		<div class="refund-address-l">退货地址：</div>
		<div class="refund-address-r">
			<p v-for="(item,key) in refund_address_info" :key="key">{{ item }}</p>
		</div>
	</div>
	<!-- 查看物流 -->
	<div v-if="status_info.display_status.refund_wuliu" class="refund-address">
		<div
		  @click="$router.push('/order/refund_logistics/' + info.refunds_sn)"
		  class="query-express"
		>
			<i class="iconfont icon-wuliu"></i> 查看物流信息<i class="iconfont icon-jiantou"></i>
		</div>
		<div class="refund-address-l">收货地址：</div>
		<div class="refund-address-r">
			<p>{{ refund_wuliu_info.real_name }} {{ refund_wuliu_info.user_phone }}</p>
			<p>{{ refund_wuliu_info.user_address }} </p>
		</div>
	</div>
	<div v-if="status_info.display_status.refund_consult" class="refund-consult">
		拒绝理由：{{ refund_consult_info }}
	</div>
	<div
	  @click="$router.push('/order/refund_consult/' + info.refunds_sn)"
	  class="refund-consult"
	>
		查看协商记录<i class="iconfont icon-jiantou"></i>
	</div>
	<div class="refund-info">
		<h2>{{ info.refunds_type_text }}信息</h2>
		<!-- 商品信息 -->
		<div class="refund-product">
			<div class="refund-product-l"><img :src="info.goods_info.image"></div>
			<div class="refund-product-r">
				<p>{{ info.goods_info.store_name }}</p>
				<p>{{ info.goods_info.suk }}</p>
				<p v-if="info.goods_info.spec_values">{{ info.goods_info.spec_values }}</p>
			</div>
		</div>
		<div class="refund-info-p" v-for="(item,key) in info.msg" :key="key">{{ item }}</div>
	</div>
	<div class="refund-footer">
		<div 
		  v-if="status_info.display_status.button_close"
		  @click="isCloseAplay = true" 
		  class="button-close-aplay"
		>
		  撤销申请
		</div>
		<div
		  v-if="status_info.display_status.button_wuliu"
		  @click="$router.push('/order/refund_express/' + info.refunds_id)"
		  class="button-green"
		>
		  填写物流
		</div>
		<div
		  v-if="status_info.display_status.button_wuliu_update"
		  @click="$router.push('/order/refund_express/' + info.refunds_id)"
		  class="button-orange"
		>
		  修改物流
		</div>
		<div
		  @click="$router.push('/order/refund_type/' + info.unique)"
		  v-if="status_info.display_status.button_update"
		  class="button-orange"
		>
		  修改申请
		</div>
		<div
		  v-if="status_info.display_status.button_receiving"
		  @click="postTakeOrder('receiving')"
		  class="button-green"
		>
		  确认收货
		</div>
	</div>
	<div v-if="isCloseAplay" class="aplay-mask"></div>
	<div v-if="isCloseAplay" class="mask-box">
		<div class="alert-box">
			<p>撤销售后申请后，本次售后申请将关闭，如后续仍有问题，你可再次发起售后申请。</p>
			<div class="button-box">
				<div @click="isCloseAplay = false" class="nodefine">暂不撤销</div>
				<div @click="postTakeOrder('close')" class="define">确定</div>
			</div>
		</div>
	</div>
	<hover-btn :kefu_display_status="kefu_display_status"></hover-btn>
  </div>
</template>

<script>
import { refundInfo, postTakeOrder } from "@api/order";
import HoverBtn from "@components/HoverBtn";
export default {
  name: "RefundStatus",
  components: {
  	  HoverBtn
  },
  data: function() {
    return {
	  isshow:false,
      isCloseAplay:false,
	  isInfoShow:true,
	  info:{},
	  status_info:{},
	  refund_address_info:{},
	  refund_consult_info:"",
	  refund_wuliu_info:{},
	  kefu_display_status: 2,//客服
    };
  },
  watch: {
    $route(n) {
      if(n.name == 'RefundStatus'){this.getRefundInfo();}
    }
  },
  mounted: function() {
	this.getRefundInfo();
  },
  methods: {
	  getRefundInfo(){
		let that = this,
		  unique = that.$route.params.id;
		refundInfo(unique).then(res => {
		  that.info = res.data.info;
		  that.status_info = res.data.status_info;
		  that.kefu_display_status = res.data.kefu_display_status;
		  that.refund_address_info = res.data.refund_address_info;
		  that.refund_consult_info =res.data.refund_consult_info;
		  that.refund_wuliu_info = res.data.refund_wuliu_info;
		  that.isshow = true;
		}).catch(err => {
		  that.$dialog.error(err.msg);
		  setTimeout(function(){
			that.$route.go(-1);
		  });
		});
	  },
	  Spread(){
		this.isInfoShow = !this.isInfoShow;
	  },
	  postTakeOrder(status){
		  let that = this;
		  that.isCloseAplay = false;
		  postTakeOrder({
			refunds_id: that.info.refunds_id,
			status: status
		  }).then(res => {
			that.$dialog.toast({mes:res.msg});
			setTimeout(function(){
			  that.$router.go(-1);
			})
		  }).catch(err => {
			that.$dialog.error(err.msg);
		  });
	  }
  }
};
</script>
<style scoped>
.refund-status .head{background-color: #fff;overflow: hidden;}
.refund-status .head h2{font-size: 0.32rem;height: 0.55rem;padding: 0 0.4rem;margin-top: 0.3rem;}
.refund-status .head>p{margin-left: 0.4rem;margin-bottom: 0.2rem;}
.refund-status .headinfo{/* border-top: 1px solid #eee; */margin: 0.2rem 0.4rem 0 0.4rem;}
.refund-status .headinfo p{margin-top: 0.05rem;color: #6a6a6a;font-size: 0.26rem;}
.refund-status .headinfo p:first-child{margin-top: 0.2rem;}
.refund-status .headinfo p:last-child{margin-bottom: 0.2rem;}
.refund-address{background-color: #fff;padding: 0.25rem 0.3rem 0.25rem 0.4rem;margin-top: 0.13rem;overflow: hidden;}
.refund-address-l,.refund-address-r{float: left;}
.refund-address-l{width: 22%;}
.refund-address-r{width: 78%;}
.refund-consult{background-color: #fff;padding: 0.25rem 0.4rem;margin-top: 0.13rem;}
.refund-consult i,.refund-address .icon-jiantou{float: right;font-size: 0.28rem;color: #999;margin-top: 0.05rem;}
.refund-info{background-color: #fff;padding: 0.3rem 0.4rem;margin-top: 0.13rem;margin-bottom: 1.5rem;}
.refund-product{background-color: #fafafa;margin: 0.3rem 0;padding: 0.2rem 0.1rem 0.2rem 0.3rem;overflow: hidden;}
.refund-product-l{width: 30%;border-radius: 7px;float: left;}
.refund-product-l img{display: block;width: 100%;}
.refund-product-r{width: 66%;float: left;margin-left: 3%;margin-top: 0.1rem;}
.refund-product-r p{margin-top: 0.1rem;}
.refund-info-p{margin-top: 0.1rem;color: #444;}
.refund-footer{background-color: #fff;padding: 0 0.4rem;position: fixed;left: 0;bottom: 0;width: 100%;border-top: 1px solid #eee;}
.refund-footer div{padding: 0.1rem;border-radius: 3px;float: right;margin: 0.2rem 0.1rem 0.2rem 0;}
.button-close-aplay{border: 1px solid #ccc;}
.button-green{border: 1px solid #53bf81;color: #53bf81;}
.button-orange{border: 1px solid darkorange;color: darkorange;}
.aplay-mask{background-color: #000;opacity: 0.5;position: fixed;left: 0;top: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 998;}
.mask-box{position: fixed;left: 0;top: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999;}
.alert-box{background-color: #fff;border-radius: 7px;width: 85%;}
.alert-box p{padding: 0.5rem;}
.button-box{display: flex;justify-content: center;border-top: 1px solid #ccc;}
.define,.nodefine{padding: 0.3rem 0;width: 50%;text-align: center;}
.define{border-left: 1px solid #ccc;color: #007AFF;}
.spread{padding: 0.15rem 0;text-align: center;/* box-shadow: 0px 0px 12px 0px #ddd; */border-top: 1px solid #eee;}
.icon-jian{font-size: 0.28rem;color: #777;}
.icon-anniu_jiantouzhankai_o{color: #777;}
.smallinfo{height: 0rem;overflow: hidden;}
.query-express{padding-bottom: 0.2rem;border-bottom: 1px solid #eee;margin-bottom: 0.2rem;font-size: 0.3rem;color: #000;}
.icon-wuliu{float: left;margin-right: 0.1rem;font-size: 0.45rem;color: #333;margin-top: -0.05rem;}
@media screen and (min-width:960px){
	.refund-status{width: 3.75rem;}
	.refund-status .head h2{font-size: 0.16rem;height: 0.27rem;padding: 0 0.2rem;margin-top: 0.15rem;}
	.refund-status .head>p{margin-left: 0.2rem;margin-bottom: 0.1rem;}
	.refund-status .headinfo{margin: 0.1rem 0.2rem 0 0.2rem;}
	.refund-status .headinfo p{margin-top: 0.02rem;font-size: 0.13rem;}
	.refund-status .headinfo p:first-child{margin-top: 0.1rem;}
	.refund-status .headinfo p:last-child{margin-bottom: 0.1rem;}
	.refund-address{padding: 0.125rem 0.15rem 0.125rem 0.2rem;margin-top: 0.06rem;}
	.refund-consult{padding: 0.125rem 0.2rem;margin-top: 0.06rem;}
	.refund-consult i,.refund-address .icon-jiantou{font-size: 0.14rem;margin-top: 0.02rem;}
	.refund-info{padding: 0.15rem 0.2rem;margin-top: 0.06rem;margin-bottom: 0.75rem;}
	.refund-product{margin: 0.15rem 0;padding: 0.1rem 0.05rem 0.1rem 0.15rem;width: 3.4rem;}
	.refund-product-r{margin-top: 0.05rem;}
	.refund-product-r p{margin-top: 0.05rem;}
	.refund-info-p{margin-top: 0.05rem;}
	.refund-footer{padding: 0 0.2rem;}
	.refund-footer div{padding: 0.05rem;margin: 0.1rem 0.05rem 0.1rem 0;}
	.alert-box p{padding: 0.25rem;}
	.define,.nodefine{padding: 0.15rem 0;}
	.spread{padding: 0.07rem 0;}
	.icon-jian{font-size: 0.14rem;}
	.query-express{padding-bottom: 0.1rem;margin-bottom: 0.1rem;font-size: 0.15rem;}
	.icon-wuliu{margin-right: 0.05rem;font-size: 0.22rem;margin-top: -0.02rem;}
}
</style>